interface ENV {
  [key: string]: any;
}

const env: ENV = {
  baseGatewayUrl: process.env.REACT_APP_BASE_GATEWAY_URL,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  appleClientId: process.env.REACT_APP_APPLE_CLIENT_ID,
  appleRedirectUri: process.env.REACT_APP_APPLE_REDIRECT_URI
};

export default env;
